import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
} from '../../../../../_metronic/helpers'
import {useDLMTypesQueryResponse, useDLMTypesQueryResponseData} from './DLMTypesQueryResponseProvider'

const DLMTypesListViewContext = createContext<ListViewContextProps>(initialListView)

const DLMTypesListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const [itemIdForDelete, setItemIdForDelete] = useState<ID>(initialListView.itemIdForDelete)
  const {isLoading} = useDLMTypesQueryResponse()
  const data = useDLMTypesQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  return (
    <DLMTypesListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        itemIdForDelete,        
        setItemIdForUpdate,
        setItemIdForDelete,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
      }}
    >
      {children}
    </DLMTypesListViewContext.Provider>
  )
}

const useDLMTypesListView = () => useContext(DLMTypesListViewContext)

export {DLMTypesListViewProvider, useDLMTypesListView}
